import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'columnTranslate',
  pure: false // Make it impure to react to language changes
})
export class ColumnTranslatePipe implements PipeTransform {
  
  constructor(private translateService: TranslateService) {}

  transform(columnName: string): string {
    if (!columnName) return '';
    
    // Convert snake_case to UPPER_CASE for translation key
    const translationKey = `COLUMNS.${columnName.toUpperCase()}`;
    
    // Try to get translation
    const translation = this.translateService.instant(translationKey);
    
    // If translation exists and is different from the key, return it
    if (translation && translation !== translationKey) {
      return translation;
    }
    
    // Fallback: convert snake_case to Title Case
    return columnName
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
}
